module.exports = __webpack_public_path__ + "static/media/car2-logo2.d787b9b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/brand/car2-logo2.png
// module id = 702
// module chunks = 0